import { fromJS } from 'immutable';
import { FLIP, LANDED, SEEN, TOSS } from './constants';
import { APP_RESET } from '../App/constants';

const initialState = fromJS({
  // The coins being tossed now: { version, flips, waitForTap, flipping }, or null.
  tossing: null,
  // The newest flips tossed or already seen, by the game version they happened in.
  seenVersion: null,
});

function reducer(state = initialState, action) {
  switch (action.type) {
    case TOSS:
      return state.set('tossing', { ...action.payload, flipping: !action.payload.waitForTap })
        .set('seenVersion', action.payload.version);

    case FLIP:
      return state.get('tossing') ? state.set('tossing', { ...state.get('tossing'), flipping: true }) : state;

    case LANDED:
      return state.set('tossing', null);

    case SEEN:
      return state.set('seenVersion', action.payload.version);

    case APP_RESET:
      return initialState;

    default:
      return state;
  }
}

export default reducer;
